<!--
 * @Description : 修改登录密码
 * @Author      : pishengjun
 * @Date        : 2022-11-22 14:11:53
-->
<template>
  <a-modal v-model:open="myVisible" :title="null" :keyboard="false" :maskClosable="false" :footer="null" :closable="closable" width="480px">
    <div class="changeBox" @click.self="onFocus">
      <div class="title" @click.self="onFocus">修改登录密码</div>
      <a-form :model="formState" name="basic" autocomplete="off" class="myForm" @finish="onFinish" @click.self="onFocus">
        <!-- 通过手机短信修改密码 -->
        <template v-if="checkType == 1">
          <div class="oldPhone">
            <span class="oldPhoneTxt" @click.self="onFocus">已绑定手机号： {{ telNumberShow(formState.oldPhone) }}</span>
            <div class="mySendSms">
              <sendPhonecode :phone="formState.oldPhone" :type="6" :isUserPhoneExist="false" :isHiddenSms="isHiddenSms" />
            </div>
          </div>
          <a-form-item name="oldPhoneCode" :rules="[{ required: true, message: '请输入短信验证码' }]">
            <a-input v-model:value="formState.oldPhoneCode" class="h-50" placeholder="请输入短信验证码" @click="onFocus">
              <template #prefix>
                <img src="@/assets/images/yanzhengma.png" />
              </template>
            </a-input>
          </a-form-item>
        </template>

        <!-- 通过旧密码修改密码 -->
        <template v-else>
          <a-form-item name="oldPassWord" :rules="[{ required: true, message: '请输入原登录密码' }]">
            <a-input-password v-model:value="formState.oldPassWord" class="h-50" placeholder="请输入原登录密码" @click="onFocus">
              <template #prefix>
                <img src="@/assets/images/mima.png" />
              </template>
            </a-input-password>
          </a-form-item>
        </template>

        <!-- 新密码设置 -->
        <a-form-item name="newPassWord" :rules="[{ validator: validator.password }]" class="phoneItem">
          <a-input-password v-model:value="formState.newPassWord" class="h-50" placeholder="设置新登录密码" @click="onFocus">
            <template #prefix>
              <img src="@/assets/images/mima.png" />
            </template>
          </a-input-password>
        </a-form-item>
        <a-form-item name="newPassWordAgain" :rules="[{ validator: validatePasswordAgain }]">
          <a-input-password v-model:value="formState.newPassWordAgain" class="h-50" placeholder="请再次输入新登录密码" @click="onFocus">
            <template #prefix>
              <img src="@/assets/images/mima.png" />
            </template>
          </a-input-password>
        </a-form-item>

        <!-- 提交按钮 -->
        <div class="btns">
          <a-button type="primary" class="h-50 btn" block html-type="submit">确定修改</a-button>
          <a-button type="link" class="h-50 btn" block @click="onClickType">{{ checkType == 1 ? "原密码修改密码" : "验证码修改密码" }}</a-button>
        </div>
      </a-form>
    </div>
  </a-modal>
</template>

<script lang="ts">
import { computed, defineComponent, onMounted, reactive, toRefs } from "vue";
import sendPhonecode from "@/components/sendPhonecode/index.vue";
import { user, login } from "@/http/api";
import { notification } from "ant-design-vue";
import { validator } from "@/utils/validator";
import { Base64 } from "js-base64";
import { store } from "@/store";
import { FaceRecognitionServiceClass } from "@/http/api/FaceRecognitionService";
import { useRoute } from "vue-router";

export default defineComponent({
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    // 修改登录密码的类型  0-密码  1-短信
    type: {
      type: Number,
      default: 0,
    },
    // 是否显示右上角的关闭按钮
    closable: {
      type: Boolean,
      default: true,
    },
  },
  components: { sendPhonecode },
  emit: ["update:open"],
  setup(props, { emit }) {
    const query:any = useRoute().query;
    onMounted(() => {
      state.formState.oldPhone = store.state.currentRegisterUser?.contactNumber;
    });
    const state = reactive({
      checkType: props.type,
      isHiddenSms: false,
      formState: {
        oldPhone: "",
        oldPhoneCode: "",
        oldPassWord: "",
        newPhone: "",
        newPhoneCode: "",
        newPassWord: "",
        newPassWordAgain: "",
      },
    });
    const event = {
      onFinish() {
        const { checkType } = state;
        // 通过旧密码修改
        if (checkType == 0) {
          const { oldPassWord, newPassWord } = state.formState;
          const data = { oldPassWord: Base64.encode(oldPassWord), newPassWord: Base64.encode(newPassWord) };
          user.User.PATCH.updatePassword(data,query.id).then(() => event.changeSuccess());
        }
        // 通过短信验证码修改
        if (checkType == 1) {
          const { oldPhone, oldPhoneCode, newPassWord } = state.formState;
          const data = {
            phone: Base64.encode(oldPhone),
            code: Base64.encode(oldPhoneCode),
            newPassword: Base64.encode(newPassWord),
          };
          login.Login.PATCH.resetPassword(data).then(() => event.changeSuccess());
        }
      },
      // 手机号隐藏中间4位数
      telNumberShow: (cellValue) => {
        if (Number(cellValue) && String(cellValue).length === 11) {
          var mobile = String(cellValue);
          var reg = /^(\d{3})\d{4}(\d{4})$/;
          return mobile.replace(reg, "$1****$2");
        } else {
          return cellValue;
        }
      },
      // 关闭弹窗
      close() {
        emit("update:open", false);
      },
      // 输入框获取焦点时隐藏发送验证码的弹窗验证码区域
      onFocus() {
        state.isHiddenSms = !state.isHiddenSms;
      },
      onClickType() {
        state.checkType = state.checkType == 1 ? 0 : 1;
      },
      async changeSuccess() {
        notification.success({ message: "操作成功", description: "登录密码修改成功，请在下次使用新的密码进行登录！" });
        await FaceRecognitionServiceClass.GetCurrentRegisterUser()
        event.close();
      },
    };
    const myVisible = computed({
      get: () => props.open === true,
      set: (bool: boolean) => emit("update:open", bool),
    });

    const validatePasswordAgain = (rule, value: string) => {
      if (!value) {
        return Promise.reject("请输入密码");
      } else if (value != state.formState.newPassWord) {
        return Promise.reject("两次输入的密码不一致");
      } else {
        return Promise.resolve();
      }
    };

    return {
      ...toRefs(state),
      ...event,
      myVisible,
      validator,
      validatePasswordAgain,
    };
  },
});
</script>

<style lang="less" scoped>
.changeBox {
  .h-50 {
    height: 50px;
  }
  .title {
    text-align: center;
    font-size: 22px;
    font-weight: bold;
    color: #333;
    margin: 10px 20px;
  }
  .oldPhone {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    margin-bottom: 10px;
    position: relative;
    z-index: 4;
    .oldPhoneTxt {
      font-size: 16px;
      font-weight: bold;
    }
    .mySendSms {
      position: relative;
    }
  }
  .myForm {
    margin: 30px 20px 0;
    .btn {
      font-size: 16px;
      margin-bottom: 10px;
      &:last-child {
        margin-bottom: 0;
      }
    }
    .phoneItem {
      position: relative;
      z-index: 3;
    }
  }
}
</style>
